import { render, staticRenderFns } from "./AgentCredits.vue?vue&type=template&id=3607b80e&scoped=true&"
import script from "./AgentCredits.vue?vue&type=script&lang=js&"
export * from "./AgentCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3607b80e",
  null
  
)

export default component.exports